const GlobalStore = {
    state: {
        isSellsy: false,
        userPermissions: {},
        countries: [],
        billingLocales: [],
        steps: {
            list: [],
            activeStep: {}
        },
    },
    mutations: {
        // is sellsy
        setIsSellsy(state, data) { state.isSellsy = data },
        // user permissions
        setUserPermissions(state, data) { state.userPermissions = data },
        // countries
        setCountries(state, data) { state.countries = data },
        // billing locales
        setBillingLocales(state, data) { state.billingLocales = data },
        // Steps
        setSteps(state, steps) { state.steps.list = steps },
        setActiveStep(state, step) { state.steps.activeStep = step },
    },
    actions: {
        defineUserAsSellsy({ commit }, value) { commit("setIsSellsy", value) },
        defineUserPermissions({ commit }, value) { commit("setUserPermissions", value) },
        defineCountries({ commit }, value) { commit("setCountries", value) },
        defineBillingLocales({ commit }, value) { commit("setBillingLocales", value) },
        // Steps
        defineSteps({ commit }, steps) { commit("setSteps", steps) },
        defineActiveStep({ commit }, value) { commit("setActiveStep", value) },
        goToStep({ commit, state }, id) {
            let step = state.steps.list.find(step => step.id === id);
            if (step !== undefined) {
                commit("setActiveStep", step);
            }
        },
        changeActiveStep({ commit, state}, int) {
            let i = state.steps.list.indexOf(state.steps.activeStep);
            let step = state.steps.list[i + int];
            if (step !== undefined) commit("setActiveStep", step);
        },
        nextStep({ dispatch }) { dispatch("changeActiveStep", 1) },
        previousStep({ dispatch }) { dispatch("changeActiveStep", -1) },
    },
    getters: {
        countries: state => state.countries,
        billingLocales: state => state.billingLocales,
        userIsSellsy: state => state.isSellsy,
        userPermissions: state => state.userPermissions,

        // Steps
        activeStep: state => state.steps.activeStep,
        stepsList: state => state.steps.list,
    }
}

export default GlobalStore;